import React from "react";
import "./TrustpilotRating.css";
import { useBrand } from "../../../hooks/useBrand";

export default function TrustpilotRating() {
  const brand = useBrand();

  // Hide rating for MLM brand
  if (brand.id === 'MLM') {
    return null;
  }

  const rating = brand.rating || 4;
  const maxStars = 5;

  // Orange 400 color
  const starColor = "#fb923c";

  // Set source text based on brand
  const sourceText = `Rated ${rating} on Google`;

  const renderStars = () => {
    const stars = [];

    for (let i = 1; i <= maxStars; i++) {
      let fillPercentage = 0;

      if (i <= Math.floor(rating)) {
        // Full star
        fillPercentage = 100;
      } else if (i === Math.ceil(rating) && rating % 1 !== 0) {
        // Half star (or partial)
        fillPercentage = (rating % 1) * 100;
      }

      stars.push(
        <div key={i} className="star-container">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {/* Background star (empty/grey) */}
            <path
              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
              fill="#e5e7eb"
            />
            {/* Foreground star (filled/orange) - with clip path for partial fill */}
            <defs>
              <clipPath id={`star-clip-${i}`}>
                <rect x="0" y="0" width={`${fillPercentage}%`} height="100%" />
              </clipPath>
            </defs>
            <path
              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
              fill={starColor}
              clipPath={`url(#star-clip-${i})`}
            />
          </svg>
        </div>
      );
    }

    return stars;
  };

  return (
    <div className={`trustpilot-rating trustpilot-rating--${brand.id.toLowerCase()}`}>
      <div className="rating-text">
        <span className="rating-value">Excellent</span>
      </div>
      <div className="stars-container">
        {renderStars()}
      </div>
      <div className="rating-source-text">
        <span className="rating-source"><strong>{sourceText}</strong></span>
      </div>
    </div>
  );
}
